import { render } from "./IntroFourthView.vue?vue&type=template&id=6978ca2b"
import script from "./IntroFourthView.vue?vue&type=script&lang=js"
export * from "./IntroFourthView.vue?vue&type=script&lang=js"

import "./IntroFourthView.vue?vue&type=style&index=0&id=6978ca2b&lang=css"

import exportComponent from "C:\\wamp64\\www\\police-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__